import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { TIME_PERIODS, TimePeriodsValue, StructureTimePeriodsValue } from "@/config/date";
import { DateRange } from "react-day-picker";
import { getDateRangeFromTimePeriod } from "./helper";
import { ChevronDown } from "lucide-react";

type TimePeriodOption = { label: string; value: string };

interface TimePeriodDropdownProps<T extends string = TimePeriodsValue> {
	value?: T;
	onChange: (timePeriodValue: T, period: DateRange | undefined) => void;
	options?: readonly TimePeriodOption[];
	showLabel?: boolean;
	className?: string;
}

export const TimePeriodDropdown = <T extends string = TimePeriodsValue>({
	value,
	onChange,
	options = TIME_PERIODS,
	showLabel = true,
	className,
}: TimePeriodDropdownProps<T>) => {
	const selectedLabel = options.find(period => period.value === value)?.label ?? "Select Time";

	const handleOnChange = (timePeriodValue: T) => {
		const range = getDateRangeFromTimePeriod(timePeriodValue as TimePeriodsValue | StructureTimePeriodsValue);
		onChange(timePeriodValue, range);
	};
	return (
		<div className={showLabel ? "flex flex-col space-y-1" : undefined}>
			{showLabel && <span className="text-xs font-medium text-muted-foreground">Period</span>}
			<DropdownMenu>
				<DropdownMenuTrigger asChild>
					<Button variant="outline" size="sm" className={`justify-start ${className ?? ""}`}>
						{selectedLabel}
						<ChevronDown className="ml-2 h-4 w-4 opacity-50" />
					</Button>
				</DropdownMenuTrigger>
				<DropdownMenuContent align="start">
					{options.map(period => (
						<DropdownMenuItem
							key={period.value}
							onSelect={() => handleOnChange(period.value as T)}
							className={value === period.value ? "font-semibold bg-muted" : ""}
						>
							{period.label}
						</DropdownMenuItem>
					))}
				</DropdownMenuContent>
			</DropdownMenu>
		</div>
	);
};
